// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"zW","sticky_header_title":"AW","stycky_header_title_mob":"BW","root_scroller":"CW","scroller":"EW","indicator":"FW","scrollButtons":"GW","selected":"HW","root_tab_scrollable":"IW","root_scroller_mob":"JW","scroller_mob":"KW","indicator_mob":"LW","selected_mob":"MW","root_tab_mob":"NW","root_tab_mob_scrollable":"OW","sticky_header_title_mob":"PW"};
    if(module.hot) {
      // 1713361654127
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  